//FormManager
import React, {Component} from "react";
import PropTypes from 'prop-types';

import EventManager from "../Event/EventManager";
import {FormManagerContext} from "./FormManagerContext";


class FormManager extends Component{

    constructor(props) {
        super(props);

        this.fields=[];

        this.isAlive = true;
        this.event = new EventManager();

        this.state = {isReadOnly:false, isProcess:false};
        this.form=React.createRef();
        this.fieldset=React.createRef();
        this.handlSubmitForm = this.submitForm.bind(this);
        this.props=props;
    }

    async setDisable(){
        await this.setState({isReadOnly:true, isProcess:true,});
        this.fieldset.current.disabled="disabled";
        this.form.current.style.pointerEvents="none";
    }

    async setEnable(){
        await this.setState({isReadOnly:false, isProcess:false,});
        this.fieldset.current.disabled=false;
        this.form.current.style.removeProperty("pointer-events") ;
    }

    async submitForm(evt){
        evt.preventDefault();
        evt.stopPropagation();
        await this.setDisable();

        if(this.props.hasOwnProperty("submit")){
            let _func=this.props.submit;
            if (_func !== null) {
                if (_func instanceof Function) {
                    await _func();
                    if(this.isAlive)  await this.setEnable();
                }else{
                    if(this.isAlive)  await this.setEnable();
                }
            }else{
                if(this.isAlive)  await this.setEnable();
            }
        }
        return false;
    }


    render() {
        const {
            children,
            className,
        } = this.props;

        return (
            <React.Fragment>
                <form className={className}  ref={this.form} onSubmit={this.handlSubmitForm} method="Post">
                    <fieldset ref={this.fieldset} >
                        <FormManagerContext.Provider value={this.state}>
                        {children}
                        </FormManagerContext.Provider>
                    </fieldset>
                </form>
            </React.Fragment>
        )
    }

    destroy() {
        if (!this.isAlive) {
            return;
        }

        this.event.unbindAll();
        this.isAlive = false;
    }

    componentWillUnmount() {
        this.destroy();
    }
}

FormManager.propTypes = {
    submit: PropTypes.func,
    className: PropTypes.string,

};

FormManager.defaultProps = {};

export default FormManager;

